/*
    Base class that's used to reduce the repetition of implementing a way to attach controls.
*/

export abstract class Control {
    protected container: Element;
    private static instanceMap: WeakMap<Element, Control> = new WeakMap<Element, Control>();

    protected constructor(containerElement: Element) {
        this.container = containerElement;
        Control.instanceMap.set(containerElement, this);
    }

    public static attach<T extends Control>(Type: new (containerElement: Element) => T, selector: string | NodeListOf<Element>): T[] {
        const controlElements = typeof(selector) == "string" ? document.body.querySelectorAll(selector) : selector;
        return Array.from(controlElements).map(x => {
            x.setAttribute("data-oi-name", this.getControlAlias());
            return new Type(x);
        });
    }

    public static getInstances<T extends Control>() : T[] {
        const controlElements = document.querySelectorAll(`[data-oi-name='${this.getControlAlias()}']`);
        const controlArray: T[] = [];

        for (let i = 0; i < controlElements.length; i++)
        {
            const instance = Control.instanceMap.get(controlElements[i]) as T;
            if (instance)
                controlArray.push(instance);
        }

        return controlArray;
    }

    public static getControlAlias(): string {
        return this.name.toLowerCase();
    }
}

